import {ContentState} from '../../store';

export const initialAwsS3ContentState: ContentState = {
  init: false,
  form: {
    key: null,
    integration_id: '',
    attachments: [],
  },
  isPreview: false,
  tmpForm: {},
}
